// extracted by mini-css-extract-plugin
export default {"navList":"SettingsNavList_navList__4t6S2"};